<template>
    <div class="container remove-padding-margin">
        <div class="container remove-padding-margin" id="setsallary">
            <div class="fixed-judul fixed-top">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                        <img src="../../assets/gambar/back-blue.svg" alt="">
                    </div>
                    <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                        <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Pengaturan Gaji</h6>
                    </div>
                    <div class="col-md-2 col-sm-2 col-2">
                    </div>
                </div>
            </div>
            <main class="add-padding-default">
                <div class="flex-100">
                    <div class="flex-1 pad-top-66" v-if="listgaji.length===0">
                        <div class="mar-top-40">
                            <div class="image text-alignC">
                                <img class="" src="../../assets/icons/Vector.svg" alt="">
                            </div>
                            <div class="font-16 font-weight-bold text-center">
                                Gaji Belum diatur
                            </div>
                            <div class="font-14 text-center color-8080 mar-bottom-30">
                                Klik tombol dibawah untuk menambahkan
                            </div>
                            <div
                                class="d-flex justify-content-center"
                                @click="validateAccess('salary.create') && gojenisgaji()"
                                style="gap: 20px"    
                            >
                                <div class="pointer-with-nav position-static">
                                    <span><img class="plus-icon-blue" src="../../assets/img/plus-1.svg" alt=""></span>
                                </div>
                                <div class="">Tambahkan Jenis Gaji</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 pad-top-66" v-else>
                        <div v-for="(listgajiset,gajiset) in listgaji" :key="listgajiset.id">
                            <div class="row remove-margin" v-if="listgajiset.id == 1">
                                <div class="test flex-1 remove-padding">
                                    <label class="remove-margin mar-top-16 color-label font-14" v-bind:for="listgajiset.id">{{listgajiset.text}}</label>
                                    <div class="input-group remove-padding">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">Rp</div>
                                        </div>
                                        <input type="tel" class="form-control inputs font-16" placeholder="14.000" v-bind:id="'gajiset'+listgajiset.id" :value="listgajiset.nominal"  v-on:keyup="inputnumberpokok(listgajiset.id)">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">{{listgajiset.type}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="hash" style="padding-left: 12px" @click="modaldel(listgajiset,gajiset)">
                                    <span><img class="plus-icon" src="../../assets/icons/closesred.svg" alt=""></span>
                                </div>
                            </div>

                            <div v-else>
                                <div class="row remove-margin">
                                    <div class="test remove-padding flex-1">
                                        <label class="remove-margin mar-top-16 color-label font-14" v-bind:for="listgajiset.id">{{listgajiset.text}}</label>
                                        <div class="input-group remove-padding">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">Rp</div>
                                            </div>
                                            <input type="tel" class="form-control inputs font-16" placeholder="14.000" v-bind:id="'gajiset' +listgajiset.id" :value="listgajiset.nominal"  v-on:keyup="inputnumberpokok(listgajiset.id)">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text font-16">{{listgajiset.type}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hash" style="padding-left: 12px" @click="modaldel(listgajiset,gajiset)">
                                        <span><img class="plus-icon" src="../../assets/icons/closesred.svg" alt=""></span>
                                    </div>
                                </div>
                            </div>
	                        <div class="row remove-margin" v-if="listgajiset.id == 1">
		                        <div class="font-12 color-6f7 letter-space-002 line-height-18 mar-top-bot-4">Periode dapat ditentukan saat pembayaran gaji</div>
	                        </div>

                        </div>

                        <div class="mar-top-20" @click="validateAccess('salary.create') && gojenisgaji()" style="position: relative">
                            <div class="pointer-with-nav-input">
                                <span><img class="plus-icon-blue" src="../../assets/img/plus-1.svg" alt=""></span>
                            </div>
                            <div class="" style="padding-left: 25px">Tambahkan Jenis Gaji</div>
                        </div>
                    </div>
                    <div class="button-lanjut ">
                        <button class="btn btn-login btn-long remove-margin" :disabled="!validateAccess('salary.update')" id="btnsetgaji" @click="updategaji">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span><span id="textbtnsetgaji">Simpan</span>
                        </button>
                    </div>
                    <div class="modal fade" id="modaldel" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Hapus Gaji Karyawan </h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div>Yakin ingin menghapus <b>{{this.namagaji}}</b> pada <b>{{this.namakaryawan}}</b>?</div>
                                </div>
                                <div class="modal-footer remove-mar-lr">
                                    <div style="margin-right: 0px">
                                        <button  type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" @click="deletegaji">Ya,Hapus
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="modalmaintance" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Under Maintance</h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="font-weight-bold color-206CF">Under Maintance</div>
                                </div>
                                <div class="modal-footer remove-mar-lr">
                                    <div style="margin-right: 0px">
                                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" >UNDER MAINTANCE
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
        <CategorySallary v-bind:class="{hidesection: !issetcategory}" v-on:iskategori="iskategori" v-bind:setidkaryawangaji="setidkaryawan" ref="getdatajenis" />
    </div>
</template>
<script>
    import CategorySallary from "./CategorySallary";
    export default {
        name: "SallarySet",
        props:['setidkaryawan'],
        components: {
            CategorySallary
        },
        data(){
            return{
                idkaryawan:this.setidkaryawan,
                isClicked:false,
                isClickedloader:false,
                issetcategory:false,
                listgaji:[],
                arrayygaji:[],
                namagaji:'',
                namakaryawan:'',
                inputgaji:[] ,
                id:'',
                idgaji:'',
                keygaji:0,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted(){
            this.idkaryawan = this.$route.params.idkaryawan
            // this.smartTrackingView("pengaturan_gaji_karyawan",{"idkaryawan":this.idkaryawan});

            // this.getdatagaji()
            // $('#loadingPage').hide()
            // $('#close').hide()
            // $('#closeS').hide()

        },
        methods:{
            iskategori(){
                $('#setsallary').show()
                this.issetcategory = false
                this.getdatagaji()
            },

            gojenisgaji() {
                this.issetcategory = true;
                $('#setsallary').hide();
                this.$refs.getdatajenis.getgajinonaktif()
            },

            modaldel(listgajiset,gajiset){
                this.keygaji=gajiset;
                this.idgaji=listgajiset.id;
                this.namagaji=listgajiset.text;
                this.namakaryawan=listgajiset.nama;
                $('#modaldel').modal('show')
            },
            back(){
                this.$emit('isdetail')
            },
            inputnumberpokok(key){
                var handleevent = $('#gajiset'+key).val();
                var handlenumber = handleevent.replace(/[^0-9]+/g,'');
                $('#gajiset'+key).val(handlenumber)
                this.formatrupiah(key)
            },

            formatrupiah(key){
                var rupiah = $('#gajiset'+key).val();
                var formattedrupiah = this.newrupiah(rupiah);
                $('#gajiset'+key).val(formattedrupiah)
            },

            newrupiah(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka

                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            async getdatagaji(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                this.listgaji = []
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_gaji_aktif?idkaryawan=' + this.setidkaryawan, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            var type ='-'
                            if(rawtahapan[i].jenis_gaji.type===1){
                                type = 'Per Periode'
                            }
                            else if(rawtahapan[i].jenis_gaji.type===2){
                                type = 'Perkehadiran'
                            }
                            else if(rawtahapan[i].jenis_gaji.type===3){
                                type = 'Perjam'
                            }
                            else{
                                type = '-'
                            }
                            var nominal = rawtahapan[i].nominal;
                            var toRp = this.newrupiah(nominal.toString());
                            this.listgaji.push({
                                id: rawtahapan[i].idjenis,
                                text: rawtahapan[i].jenis_gaji.nama ,
                                nominal : toRp,
                                nama : rawtahapan[i].karyawan.nama,
                                type : type
                                })
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked=false
	                $('#textbtnsetgaji').show()
	                $('#btnsetgaji').prop('disabled', false);
	                $('#loadingPage').hide()
                }
            },
            async deletegaji(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const deletegaji = new FormData()
                    deletegaji.append('jenis_gaji', this.idgaji)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/gaji/ubah_jenisgaji_ke_nonaktif?idkaryawan=' + this.setidkaryawan , deletegaji, this.requestHeaders)
                    if (response.status === 200) {
                        if(response.data.status===true){
                            this.isClickedloader = false;
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            this.getdatagaji()
	                        this.$toast.success(response.data.msg)
                        }else{
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
	                        this.$toast.error("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti")
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked=false
	                $('#textbtnsetgaji').show()
	                $('#btnsetgaji').prop('disabled', false);
	                $('#loadingPage').hide()
                }
            },

            arraygaji(){
                var arraygaji = this.listgaji;
                this.arrayygaji = [];
                for (var i = 0; i < arraygaji.length; i++) {
                    var gajinominal = "";
                    gajinominal = $("#gajiset" + arraygaji[i].id).val();
                    this.arrayygaji.push({idjenis:arraygaji[i].id, nominal:gajinominal});
                }
            },

            async updategaji(){
                this.arraygaji();
                this.isClicked = true;
                $('#textbtnsetgaji').hide()
                $('#btnsetgaji').prop('disabled', true);
              try {
                  var gaji = this.arrayygaji
                  var editgaji ={
                      "idkaryawan" : this.setidkaryawan,
                      "gaji" : gaji

                  }
                  const response = await this.$axios.post(this.$baseurl + '/masterData/gaji/update_pengaturan_gaji_karyawan',JSON.stringify(editgaji) ,{
                      headers: {
                          'Content-type': 'application/json',
                          'Authorization': 'Bearer ' + localStorage.getItem('token'),
                      }
                  })
                  if (response.status === 200) {
                      if(response.data.status===true) {
                      	  this.$toast.success(response.data.msg)
                          this.isClicked = false;
                          $('#textbtnsetgaji').show();
                          $('#btnsetgaji').prop('disabled', false);
                          this.back()
                      } else {
                      	  this.$toast.error(response.data.msg)
                      }
                  }
              }  catch (e) {
              	  this.$catch_error_response(e)
	              $('#loadingPage').removeClass('overlayLoading');
	              $('#loadingPage').hide()
	              this.isClicked=false
	              $('#textbtnsetgaji').show()
	              $('#btnsetgaji').prop('disabled', false);
	              $('#loadingPage').hide()
              }
                this.smartTrackingClick("simpan_pengaturan_gaji_karyawan",{"idkaryawan":this.idkaryawan});

            },


        }
    }
</script>

<style scoped>
    .image.text-alignC {
        margin-bottom: 20px;
    }
    .pointer-with-nav {
        display: flex;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #206CFF;
        cursor: pointer;
        box-shadow: 0px 4px 12px
        rgba(0, 0, 0, 0.15);
        align-content: center;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 292px;
        left: 80px;
    }
    .pointer-with-nav-input {
        display: flex;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #206CFF;
        cursor: pointer;
        box-shadow: 0px 4px 12px
        rgba(0, 0, 0, 0.15);
        align-content: center;
        align-items: center;
        justify-content: center;
        position: absolute;
        /*top: 301px;*/
        /*left: 17px;*/
    }
    .plus-icon{
        width: 32px;
    }

    .plus-icon-blue{
        width: 20px;
    }

    .hash{
        display: flex;
        align-items: flex-end;
    }

    .z-index999{
        z-index: 9999;
    }

    .display-none{
        display: none !important;
    }

    .show-display{
        display: block !important;
    }

</style>